const pillars = [
  {
    num: "01",
    title: "Discretion",
    body: "Your privacy is absolute. We operate with the confidence of a private institution — never disclosed, never compromised.",
  },
  {
    num: "02",
    title: "Precision",
    body: "Every element is considered with care. Nothing is incidental. Every detail earns its place.",
  },
  {
    num: "03",
    title: "Entirely Bespoke",
    body: "Each experience is built from a blank page. Your vision, your occasion, your atmosphere.",
  },
];

export default function WhySection() {
  return (
    <section className="bg-[#0E0C0A] py-28 md:py-40 px-8 md:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-32 items-center">

          {/* Left image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative w-full h-[560px] md:h-[680px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/4cbbebe4258f6d8278c482ce3010a420.jpg"
                alt="Refined hospitality service — Table Privé"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
            </div>
            {/* Floating detail */}
            <div className="absolute -right-3 md:-right-8 bottom-10 bg-[#FAF8F5] px-6 py-5">
              <p className="font-serif text-[#1A1A1A] text-4xl mb-1">98%</p>
              <p className="text-[#8A7F74] text-[11px] font-light tracking-widest uppercase">Return &amp; referral</p>
            </div>
          </div>

          {/* Right content */}
          <div className="order-1 lg:order-2">
            <span className="text-[#C9A961] tracking-[0.3em] text-[10px] uppercase font-light block mb-8">
              The Standard
            </span>
            <h2 className="font-serif text-[#F0EBE3] text-4xl md:text-5xl font-light leading-[1.15] mb-16">
              Refinement is not<br />
              a feature.<br />
              <em className="italic text-[#C9A961]">It is the foundation.</em>
            </h2>

            <div className="space-y-10 border-t border-white/8 pt-10">
              {pillars.map((p) => (
                <div key={p.num} className="flex items-start gap-7 border-b border-white/8 pb-10 last:border-0 last:pb-0">
                  <span className="font-serif text-[#C9A961]/40 text-xs tracking-[0.2em] pt-1 flex-shrink-0 w-6">
                    {p.num}
                  </span>
                  <div>
                    <h3 className="font-serif text-[#F0EBE3] text-lg mb-2 font-light">{p.title}</h3>
                    <p className="text-[#6A6259] text-sm font-light leading-relaxed">{p.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
